import React from 'react'
import { ArticleEntity } from 'graphql/generated/types'

function makeArticleSchema(articleData: ArticleEntity) {
  const {
    slug,
    title,
    description,
    plugin_comments: comments,
    short_description: shortDescription,
    createdAt,
  } = articleData.attributes

  const commentCount = comments.length

  const suggestedAnswer = [
    {
      '@type': 'Answer',
      text: description,
      url: `https://app.fintrakk.com/article/${slug}#suggestedAnswer`,
    },
  ]
  comments.forEach((comment) => {
    const suggestedAnswerData = {
      '@type': 'Answer',
      text: comment.content,
      url: `https://app.fintrakk.com/article/${slug}#${Date.parse(createdAt)}`,
    }

    suggestedAnswer.push(suggestedAnswerData)
  })

  return {
    '@context': 'http://schema.org',
    '@type': 'QAPage',
    mainEntity: {
      '@type': 'Question',
      name: title,
      answerCount: commentCount + 2,
      acceptedAnswer: {
        '@type': 'Answer',
        text: shortDescription,
        url: `https://app.fintrakk.com/article/${slug}#acceptedAnswer`,
      },
    },
    suggestedAnswer,
  }
}

export default function Schema({ articleData }) {
  return (
    <script
      key={`jobJSON-${articleData.id}`}
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(makeArticleSchema(articleData)),
      }}
    />
  )
}

// Schema.propTypes = {
//   articleData: PropTypes.shape({
//     id: PropTypes.string.isRequired,

//     title: PropTypes.string.isRequired,

//     description: PropTypes.string.isRequired,

//     shortDescription: PropTypes.string.isRequired,

//     created_at: PropTypes.string.isRequired,

//     article_comments: PropTypes.arrayOf(PropTypes.string.isRequired),
//   }).isRequired,
// }
